<template>
  <div class="container-plus">
    <button
      :disabled="disabledDownload"
      class="btn-plus-file b-radius"
      @click="$emit('toggle-more-types')"
    >
      <span>+</span>
    </button>
    <div v-show="showMoreTypes" class="container-plus-formats">
      <button
        :disabled="disabledDownload"
        class="btn-file b-radius"
        @click="$emit('authorize-download', { size: vectorDefaultSize, type: 'eps' })"
      >
        <span v-if="!loading.eps">{{ $t('preview.download.main.eps') }}</span>
        <b-spinner v-else small variant="light" class="ml-2"></b-spinner>
      </button>
      <button
        :disabled="disabledDownload"
        class="btn-file b-radius"
        @click="$emit('authorize-download', { size: vectorDefaultSize, type: 'psd' })"
      >
        <span v-if="!loading.psd">{{ $t('preview.download.main.psd') }}</span>
        <b-spinner v-else small variant="light" class="ml-2"></b-spinner>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    disabledDownload: {
      type: Boolean,
      required: true
    },
    showMoreTypes: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      vectorDefaultSize: 1
    };
  }
};
</script>

<style lang="scss" scoped>
button {
  background-color: #3cd699;
  border: none;
  outline: none;
  color: #fff;
}
button:disabled {
  background-color: #d2d2d2 !important;
  border-color: #d2d2d2 !important;
  cursor: not-allowed !important;
}
button:disabled:hover {
  filter: none !important;
}
.btn-plus-file {
  background-color: #34bf88;
  margin-left: 15px;
  padding-left: 15px;
  padding-right: 15px;
  font-size: 26px;
  @include md {
    margin-left: 0;
    width: 100%;
  }
}
.btn-file {
  border-top-left-radius: 23px;
  border-bottom-left-radius: 23px;
  font-size: 18px;
  padding: 12px 53px;
  margin-left: 15px;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  @include md {
    margin-left: 0;
    margin-bottom: 7px;
    flex: 1;
    max-height: 45px;
  }
}
.b-radius {
  border-radius: 23px;
}
.container-plus {
  position: relative;
  display: flex;
  z-index: 1;
}
.container-plus-formats {
  display: flex;
  position: absolute;
  top: 55px;
  right: 0;
}
</style>
